import { getSurveyTriggerCodes } from '../../authentication/utils/getSurveyTriggerCodes';
import { reValidateSession } from '../../authentication/utils/revalidateSession';
import { tcPlusCompanySettings } from '../../authentication/utils/tcPlusCompanySettings';
import { updateSessionStorageForLoggedinUser } from '../../authentication/utils/updateSessionStorage';
import { getCookie } from '../../common/utils/cookies';
import { getExperienceInitCookie } from '../../common/utils/experienceInitCookie';
import axios from '../../common/utils/interceptor';
import { redirectUrlOnAuthentication } from '../../common/utils/redirectUrlOnAuthentication';
import { registerAssessmentTCPlus } from '../../common/utils/registerAssessmentTCPlus';
import { apiUrls, routeMappings, SessionStore } from '../../constants';

export const initiateTcPlusIntegratedFlow = async (): Promise<string> => {
  const url = routeMappings['NOT_FOUND'];
  try {
    const { data: responseData } = await axios.post(apiUrls.TC_PLUS_AUTOLOGIN, {});

    if (!responseData.IsError && responseData.Success) {
      const candidate = JSON.stringify(responseData.Data?.candidate);
      const expCookie = getExperienceInitCookie();
      const tcPlusFlow = getCookie('TcPlusFlag') === '1';
      const candidateDeadlineDate = expCookie && expCookie.candidateDeadlineDate;

      /** update sessionStorage */
      updateSessionStorageForLoggedinUser(candidate, candidateDeadlineDate);

      /** revalidate session and get completed survey trigger codes, then navigate to current workflow item */
      const [reValidateSessionObj] = await Promise.all([
        reValidateSession(),
        getSurveyTriggerCodes(tcPlusFlow),
        tcPlusCompanySettings(tcPlusFlow),
      ]);

      if (tcPlusFlow) {
        const workflowSession = sessionStorage.getItem(SessionStore.workflowSession);
        const parsedWorkflowSession = workflowSession && JSON.parse(workflowSession);
        if (!parsedWorkflowSession.candidateRegistered) {
          const data = await registerAssessmentTCPlus(false, true); // resetIndicator = false, autoLogin = true
          switch (data.status) {
            case 0:
              break;

            case 200:
              await reValidateSession();
              break;

            default:
              console.error('error occurred while registering candidate');
              return url;
          }
        }
      }

      if (reValidateSessionObj.data && !reValidateSessionObj.error) {
        const url = await redirectUrlOnAuthentication(reValidateSessionObj.data);
        if (url) {
          return url;
        }
      }
    }
  } catch (e) {
    console.error('error occurred in tcplus integration flow', e);
  }
  return url;
};
